import { AnyAction } from "redux";
import { Dispatch } from "react";
import { CommonsCapacitiesRaw, Result, } from "../../../../interfaces";
import { Create } from "../../../commonsCapacities";
import { Adapter } from "../../../../shared/adapter";
import { CommonsCapacitiesAdapter } from "../../../../adapter/commonsCapacities-adapter";

export const FETCH_CREATE_COMMONS_CAPACITIES_REQUEST = 'FETCH_COMMONS_CAPACITIES_REQUEST';
export const FETCH_CREATE_COMMONS_CAPACITIES_SUCCESS = 'FETCH_COMMONS_CAPACITIES_SUCCESS';
export const FETCH_CREATE_COMMONS_CAPACITIES_FAILURE = 'FETCH_COMMONS_CAPACITIES_FAILURE';

interface ActionPagination<T> {
    type: string,
    payload: T
}

const fetchCreateCommonsCapacitiesRequest = () => {
    return {
        type: FETCH_CREATE_COMMONS_CAPACITIES_REQUEST,
    };
};

const fetchCreateCommonsCapacitiesSuccess = (data: any): ActionPagination<Result<any>> => {
    return {
        type: FETCH_CREATE_COMMONS_CAPACITIES_SUCCESS,
        payload: data
    };
};

const fetchCreateCommonsCapacitiesFailure = (error: any) => {
    return {
        type: FETCH_CREATE_COMMONS_CAPACITIES_FAILURE,
        payload: error,
    };
};

export const clear = ()=>{
    return {
        type: "CLEAR_DATA",
    };  
}

export const create = (commonsCapacities:CommonsCapacitiesRaw) => {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(fetchCreateCommonsCapacitiesRequest());
        try {
            const response = await Create(commonsCapacities);
            dispatch(fetchCreateCommonsCapacitiesSuccess(
                Adapter.from(response.data).to((value) => new CommonsCapacitiesAdapter(value).adapt())
            ));
        } catch (error: any) {
            dispatch(fetchCreateCommonsCapacitiesFailure(error.message));
        }
    };
};